import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { useContext } from "react";
import { ThemeContext } from "../../hooks/ThemeContext";
import Home from "../../pages/Home/index";
import Orders from "../../pages/Order";
import Contact from "../../pages/Contact";
import Footer from "../globals/Footer";
import Navbar from "../globals/Navbar";
import NotFound from "../globals/NotFound";
import i18n from "../languages/i18n";
import Register from "../../pages/Auth/Register";
import Login from "../../pages/Auth/Login";
import Dashboard from "../../pages/Admin";
import CreatorSpace from "../../pages/CreatorSpace";
import CreatorStats from "../../pages/CreatorSpace/Stats";
import ProtectedRoute from "../globals/ProtectedRoute";
import Shop from "../../pages/Shop";
import ProductDetails from "../../pages/Shop/ProductDetails";
import ClientSpace from "../../pages/ClientSpace";
import Creations from "../../pages/Creations";
import CreationsArchive from "../../pages/CreationsArchive";
import Services from "../../pages/Services";
import DevenirCreateur from "../../pages/DevenirCreateur";
import Cart from "../../pages/Cart";
import Checkout from "../../pages/Checkout";
import PaymentSuccess from "../../pages/PaymentSuccess";
import PaymentCancel from "../../pages/PaymentCancel";
import Downloads from "../../pages/ClientSpace/Downloads";
import EmailVerify from "../../pages/EmailVerify";
import ContactCreator from "../../pages/ContactCreator";
// Composant pour changer la langue

const RouteContainer = () => {
  // Initialiser la langue à partir du localStorage
  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "fr"; // Langue par défaut
    i18n.changeLanguage(savedLanguage); // Applique la langue
  }, []);

  const { theme } = useContext(ThemeContext);

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <div className={`min-h-screen flex flex-col ${theme === 'dark' ? 'bg-[#0f1114] text-white' : 'bg-slate-50 text-gray-800'}`}>
          <Navbar />

          <main className="flex-1">
            <div className="root">
              <Routes>
                {/* Routes publiques */}
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/boutique" element={<Shop />} />
                <Route path="/shop/:id" element={<ProductDetails />} />
                <Route path="/boutique/:id" element={<ProductDetails />} />
                <Route path="/register" element={<Register />} />
                <Route path="/login" element={<Login />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/creations" element={<Creations />} />
                <Route path="/creations-archive" element={<CreationsArchive />} />
                <Route path="/services" element={<Services />} />
                <Route path="/devenir-createur" element={<DevenirCreateur />} />
                <Route path="/email/verify" element={<EmailVerify />} />
                <Route path="/contacter-createur" element={<ContactCreator />} />
                <Route path="/contacter-createur/:creatorId" element={<ContactCreator />} />
                
                {/* Routes protégées - Utilisateurs connectés */}
                <Route
                  path="/cart"
                  element={
                    <ProtectedRoute element={<Cart />} allowedRoles={[1, 2, 3]} />
                  }
                />
                <Route
                  path="/panier"
                  element={
                    <ProtectedRoute element={<Cart />} allowedRoles={[1, 2, 3]} />
                  }
                />
                <Route
                  path="/checkout"
                  element={
                    <ProtectedRoute element={<Checkout />} allowedRoles={[1, 2, 3]} />
                  }
                />
                <Route
                  path="/payment/success"
                  element={
                    <ProtectedRoute element={<PaymentSuccess />} allowedRoles={[1, 2, 3]} />
                  }
                />
                <Route
                  path="/payment/cancel"
                  element={
                    <ProtectedRoute element={<PaymentCancel />} allowedRoles={[1, 2, 3]} />
                  }
                />
                <Route
                  path="/orders"
                  element={
                    <ProtectedRoute element={<Orders />} allowedRoles={[1, 2, 3]} />
                  }
                />
                <Route
                  path="/espace-client"
                  element={
                    <ProtectedRoute element={<ClientSpace />} allowedRoles={[1, 2, 3]} />
                  }
                />
                <Route
                  path="/client-space"
                  element={
                    <ProtectedRoute element={<ClientSpace />} allowedRoles={[1, 2, 3]} />
                  }
                />
                <Route
                  path="/mes-telechargements"
                  element={
                    <ProtectedRoute element={<Downloads />} allowedRoles={[1, 2, 3]} />
                  }
                />
                <Route
                  path="/downloads"
                  element={
                    <ProtectedRoute element={<Downloads />} allowedRoles={[1, 2, 3]} />
                  }
                />
                
                {/* Route Créateurs */}
                <Route
                  path="/mes-produits"
                  element={
                    <ProtectedRoute element={<CreatorSpace />} allowedRoles={[2, 3]} />
                  }
                />
                <Route
                  path="/creator-stats"
                  element={
                    <ProtectedRoute element={<CreatorStats />} allowedRoles={[2, 3]} />
                  }
                />
                <Route
                  path="/mes-statistiques"
                  element={
                    <ProtectedRoute element={<CreatorStats />} allowedRoles={[2, 3]} />
                  }
                />
                
                {/* Route Admin uniquement */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute element={<Dashboard />} roleRequired={3} />
                  }
                />
                
                {/* Route 404 - doit être en dernier */}
                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </main>

          <Footer />
        </div>
      </Router>
    </I18nextProvider>
  );
};

export default RouteContainer;
